import { ISftpPartner } from '@core/models/sftp-transfer.model';
export function canPollPartner(direction?: string): boolean {
    const d = (direction || 'RECEIVE').toUpperCase();
    return d === 'RECEIVE' || d === 'BIDIRECTIONAL';
}

export function canSendPartner(direction?: string): boolean {
    const d = (direction || 'RECEIVE').toUpperCase();
    return d === 'SEND' || d === 'BIDIRECTIONAL';
}

export function isEnvCredentialPartner(partner: { credentialSource?: string }): boolean {
    return (partner.credentialSource || '').toUpperCase() === 'ENV';
}

export function isDbCredentialPartner(partner: { credentialSource?: string }): boolean {
    return (partner.credentialSource || '').toUpperCase() === 'DB';
}

export function credentialBadge(partner: ISftpPartner): { label: string; className: string } {
    const source = (partner.credentialSource || 'NONE').toUpperCase();
    if (source === 'ENV' && partner.credentialsConfigured) {
        return { label: 'Configured on server', className: 'bg-green-100 text-green-800' };
    }
    if (source === 'DB' && partner.credentialsConfigured) {
        return { label: 'Secured in database', className: 'bg-green-100 text-green-800' };
    }
    if (source === 'DB') {
        return { label: 'Credentials incomplete', className: 'bg-amber-100 text-amber-900' };
    }
    if (partner.credentialsConfigured) {
        return { label: 'Configured', className: 'bg-green-100 text-green-800' };
    }
    return { label: 'Not configured', className: 'bg-red-100 text-red-800' };
}

export function directionLabel(direction?: string): string {
    return (direction || 'RECEIVE').toUpperCase();
}

export function directionBadgeClass(direction?: string): string {
    const d = directionLabel(direction);
    if (d === 'SEND') return 'bg-blue-100 text-blue-800';
    if (d === 'BIDIRECTIONAL') return 'bg-purple-100 text-purple-800';
    return 'bg-green-100 text-green-800';
}

export function sortPartnersForDisplay(partners: ISftpPartner[]): ISftpPartner[] {
    const order: Record<string, number> = { RECEIVE: 0, BIDIRECTIONAL: 1, SEND: 2 };
    return [...partners].sort((a, b) => {
        const oa = order[directionLabel(a.direction)] ?? 9;
        const ob = order[directionLabel(b.direction)] ?? 9;
        return oa - ob || (a.code || '').localeCompare(b.code || '');
    });
}
